import React, { useEffect, useMemo, useState } from "react"
import { calculateTotal, calculateTotalWeight, exportToExcel, exportToPDF, filterKeys } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
} from "../../components"
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADEOF_CODE, ENUM_TRADEOF_LIST, ENUM_TRADEOF_TYPE, getModValue, getModVisiblity } from "../../constants/enum.js"
import { useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"

import { faFilter, faMagnifyingGlass, } from "@fortawesome/free-solid-svg-icons"
import { Button, Autocomplete, AutocompleteItem } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useParams } from "react-router-dom"
import { DataGrid, GridPagination, useGridApiContext } from "@mui/x-data-grid"
import { Box } from "@mui/material"
import { toast } from "react-toastify"


const Stock = () => {
  const { compCode } = useSelector((state) => state.company)
  const [selectedItem, setSelectedItem] = useState("")
  const [selTradeOf, setSelTradeOf] = useState("")
  //const [selPktType, setPktType] = useState("")
  const [selModName, setSelModName] = useState("")
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [modSettingParams, setModSettingParams] = useState("")
  const [rows, setRows] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [filterData, setFilterData] = useState([])

  const [filterModel, setFilterModel] = useState({
    items: [],
  });


  //const [Column, setInitialColumn] = useState("")
  const { stype } = useParams()

  //{ key: "", value: "" })
  //const [data, setData] = useState([])

  const { data: itemMasterData = [] } = useFetchWithBody({
    url: apiRoute.stockEntry.fetchMasterData,
    queryKey: "StockItemMaster",
  })
  const funFilterData = (tradeof, itemcode) => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        trade_of: tradeof,
        item_code: itemcode,
      }
    })
  }

  const handleResetFilter = () => {
    setSelectedItem("")
    setSelTradeOf("")
    funFilterData(null, null)
  }
  const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
    url: apiRoute.modSetting.getMultiModSetting,
    queryKey: "fetchModSettingStockItem",
  })

  const {
    data = [],
    isError,
    isPending,
    mutate: filterStock,
  } = usePost({
    url: apiRoute.stockEntry.fetchStock,
    queryKey: "GetStock",

  })
  useEffect(() => {
    setRows(data)
    setOriginalData(data)
  }, [data])
  const getModSettingName = (tradeType) => {
    let modName = ''
    if (tradeType == ENUM_TRADEOF_CODE.Polish) {
      modName = ENUM_MOD_NAME.StockPolishSingle
    }
    else if (tradeType == ENUM_TRADEOF_CODE.Rough) {
      modName = ENUM_MOD_NAME.StockRoughSingle
    }
    else if (tradeType == ENUM_TRADEOF_CODE.Rejection) {
      modName = ENUM_MOD_NAME.StockRejetionSingle
    }

    return modName
  }
  useEffect(() => {

    if (stype && stype != "") {
      if (['single', 'mix'].includes(stype)) {


      }
    }
  }, [stype])

  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "BPcs",
      }),
    [rows]
  )


  let totalWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: rows,
        columnName: "BWeight",
      }),
    [rows]
  )
  let totalAmount = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "Amount",
      }),
    [rows]
  )
  let totalAmountD = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "AmountD",
      }),
    [rows]
  )

  const handleFilter = () => {
    if (selTradeOf && selTradeOf != "" && selTradeOf != null) {
      funFilterData(selTradeOf, selectedItem)
      setFilterModel({ items: [] })
    }
    else {
      toast.error("Select Stock Of", {
        "position": "top-center"
      })
    }
  }
  let downloadDataFooter = {
    ItemName: "",
    LotNo: "",
    PktNo: "",
    ShapeName: "",
    PurityName: "",
    ColorName: "",
    SizeName: "",
    ReportNo: "",
    Lwration: "",
    BPcs: "Total: " + totalPcs,
    BWeight: "Total: " + totalWeight,
    BRated: "",
    AmountD: "Total: " + totalAmountD,
    CRate: "",
    BRate: "",
    Amount: "Total: " + totalAmount,
  }

  const ColFields = {
    ItemName: "ItemName",
    LotNo: "LotNo",
    PktNo: "PktNo",
    ShapeName: "ShapeName",
    PurityName: "PurityName",
    ColorName: "ColorName",
    SizeName: "SizeName",
    ReportNo: "ReportNo",
    LwRatio: "LwRatio"
  }


  const exportColumns = [
    {
      uid: "ItemName",
      name: "Item Name",
    },
    {
      uid: "LotNo",
      name: "Lot No.",
    },
    {
      uid: "PktNo",
      name: "Pkt No.",
    },
    {
      uid: "ShapeName",
      name: "Shape",
    },
    {
      uid: "PurityName",
      name: "Purity",
    },
    {
      uid: "ColorName",
      name: "Color",
    },
    {
      uid: "SizeName",
      name: "Size",
    },
    {
      uid: "ReportNo",
      name: "Rpt No.",
    },
    {
      uid: "LwRatio",
      name: "LxW Ratio",
    },
    {
      uid: "BPcs",
      name: "Pcs",
    },
    {
      uid: "BWeight",
      name: "Weight",
    },
    {
      uid: "Rated",
      name: "Rate($)",
    },
    {
      uid: "AmountD",
      name: "Amount($)",
    },
    {
      uid: "CRate",
      name: "Conv.Rate",
    },
    {
      uid: "BRate",
      name: "Rate",
    },
    {
      uid: "Amount",
      name: "Amount",
    },
  ]
  const [exportData, setExportData] = useState(exportColumns)
  const INITIAL_VISIBLE_COLUMNS = [
    "ItemName",
    "LotNo",
    "PktNo",
    "ShapeName",
    "PurityName",
    "ColorName",
    "SizeName",
    "BPcs",
    "BWeight",
    "CRate",
    "BRated",
    "AmountD",
    "BRate",
    "Amount",
  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)
  const RowsField = {
    id: "id",
    LotNo: "LotNo",
    PktNo: "PktNo",
    // LwRatio: "L",
    Shape: "ShapeName",
    Item: "ItemName",
    Color: "ColorName",
    Purity: "PurityName",
    Size: "SizeName",
    Pcs: "BPcs",
    Weight: "BWeight",
    ConvRate: "CRate",
    RateD: "BRated",
    AmountD: "AmountD",
    Rate: "BRate",
    Amount: "Amount",
    ReportNo: "ReportNo",
    LwRatio: "LwRatio"
  }
  const emptyRowField = Object.keys(RowsField).reduce((acc, key) => {
    if ([RowsField.AmountD, RowsField.Amount,].includes(key))
      acc[key] = 0
    acc[key] = ""
    return acc
  }, {})
  const itemGridHeadClass = "report-grid-style"
  const setColumnVisiblity = (column) => {
    if (initialColumn.includes(column))
      return true
    else return false
  }
  const setCurrencyColumnVisiblity = (column) => {
    const RsCol = [RowsField.Rate, RowsField.Amount]
    const DCol = [RowsField.RateD, RowsField.AmountD, RowsField.ConvRate]
    if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
      return true
    else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
      return true
    else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
      return true
    else
      return false
  }
  const columns = [
    {
      field: RowsField.LotNo,
      headerName: "Lot No.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.PktNo,
      headerName: "Pkt No.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Item,
      headerName: "Item.",
      minWidth: 95,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Shape,
      headerName: "Shape.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Purity,
      headerName: "Purity.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Color,
      headerName: "Color.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Size,
      headerName: "Size.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.ReportNo,
      headerName: "Report No.",
      minWidth: 50,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },

    {
      field: RowsField.LwRatio,
      headerName: "LxW Ratio",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Pcs,
      headerName: "Pcs",
      minWidth: 50,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.Weight,
      headerName: "Weight",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass
    },
    {
      field: RowsField.ConvRate,
      headerName: "Conv Rate",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass

    },
    {
      field: RowsField.RateD,
      headerName: "Rate ($)",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass

    },
    {
      field: RowsField.AmountD,
      headerName: "Amt. ($)",
      minWidth: 95,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass

    },
    {
      field: RowsField.Rate,
      headerName: "Rate",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass

    },
    {
      field: RowsField.Amount,
      headerName: "Amt. (Rs)",
      minWidth: 95,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass
    },
  ]
  const applyFilter = (row, filter) => {

    const { field, operator } = filter;
    //onst operator = filter.operator;
    const filterValue = filter.value;

    const cellValue = row[field];

    if (filterValue === undefined || filterValue === null) return true;

    const filterValStr = filterValue.toString().toLowerCase();
    const cellValStr = (cellValue ?? '').toString().toLowerCase();

    switch (operator) {
      case 'contains':
        return cellValStr.includes(filterValStr);
      case 'doesNotContain':
        return !cellValStr.includes(filterValStr);
      case 'doesNotEqual':
        return cellValStr !== filterValStr;
      case 'isEmpty':
        return cellValStr == filterValStr;
      case 'isNotEmpty ':
        return cellValStr !== '';
      case 'equals':
        return cellValStr === filterValStr;
      case 'startsWith':
        return cellValStr.startsWith(filterValStr);
      case 'endsWith':
        return cellValStr.endsWith(filterValStr);
      case 'isAnyOf':
        return Array.isArray(filterValue) && filterValue.includes(cellValue);
      case '=':
        return Number(cellValue) == Number(filterValue);
      case '>':
        return Number(cellValue) > Number(filterValue);
      case '>=':
        return Number(cellValue) >= Number(filterValue);
      case '<':
        return Number(cellValue) < Number(filterValue);
      case '<=':
        return Number(cellValue) <= Number(filterValue);
      default:
        return true;
    }
  };
  //console.log(rows, "data")
  // console.log(originalData, "i")
  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);

    const items = newFilterModel?.items || [];
    // const f = rows.filter((ele) => ele.id != 'total')
    // setRows(f)
    // If no filter items, show all original rows + total

    const baseData = originalData;
    const filtered = (items.length === 0)
      ? baseData
      : baseData.filter(row =>
        items.every(filter => applyFilter(row, filter)) || row.id == 'total'
      );


    // const filtered = originalData
    //   .filter((row) =>
    //     newFilterModel.items.every((filter) => applyFilter(row, filter))
    //   );
    const newFilter = filtered
    const totalRow = {
      ...emptyRowField,
      id: 'total',
      AmountD: newFilter.filter((ele) => ele.id != 'total').reduce((sum, r) => sum + (r.AmountD || 0), 0),
      Amount: newFilter.filter((ele) => ele.id != 'total').reduce((sum, r) => sum + (r.Amount || 0), 0),
    };

    const index = filtered.findIndex((item) => item.id == 'total')

    const updateRow = {
      ...filtered[index], ...totalRow
    }
    const newRows = [...filtered]
    newRows[index] = updateRow

    setRows(filtered)
  }
  // useEffect(() => {
  //   setRows(filterData)
  // }, [filterData.filterModel])

  // const footerRow = {
  //   ...emptyRowField,
  //   id: 'total',
  //   AmountD: rows.reduce((sum, r) => sum + (r.AmountD || 0), 0),
  //   Amount: rows.reduce((sum, r) => sum + (r.Amount || 0), 0),
  // };
  useEffect(() => {
    if (selModName != "") {
      filterModSetting({
        data: {
          page_mod: selModName,
          master_mod: ENUM_MOD_NAME.GeneralSettings
        }
      })
    }
  }, [selModName])

  useEffect(() => {
    if (modSetting && Object.keys(modSetting).length > 0) {
      const modData = modSetting.pageData
      const generalData = modSetting.masterData
      let currency_setting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS
      setCurrencySetting(currency_setting)
      // setModSettingParams({
      //     Visibility: {
      let visibleCol = []
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData))
        visibleCol = [...visibleCol, ColFields.ItemName]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData))
        visibleCol = [...visibleCol, ColFields.ShapeName]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData))
        visibleCol = [...visibleCol, ColFields.PurityName]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData))
        visibleCol = [...visibleCol, ColFields.SizeName]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData))
        visibleCol = [...visibleCol, ColFields.ColorName]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData))
        visibleCol = [...visibleCol, ColFields.LotNo]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData))
        visibleCol = [...visibleCol, ColFields.PktNo]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData))
        visibleCol = [...visibleCol, ColFields.ReportNo]
      if (getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData))
        visibleCol = [...visibleCol, ColFields.LwRatio]
      let currencyColumn = ["BRate", "Amount"]
      if (currency_setting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        currencyColumn = ["CRate", "BRated", "AmountD"]
      else if (currency_setting == ENUM_CURRENCY_SETTING_VAL.DUAL)
        currencyColumn = ["CRate", "BRated", "AmountD", "BRate", "Amount"]

      setModSettingParams([...visibleCol, "BPcs", "BWeight", ...currencyColumn])

      //setMixStockParams(mStockParam)
      // const show_Column = [...visibleCol, 'Pcs', 'Weight', ...currencyColumn]
      //   setInitialColumn(show_Column)




    }

  }, [modSetting])

  const getSelStockType = () => {
    if (selTradeOf == ENUM_TRADEOF_CODE.Polish)
      return ENUM_TRADEOF_TYPE.Polish
    else if (selTradeOf == ENUM_TRADEOF_CODE.Rough)
      return ENUM_TRADEOF_TYPE.Rough
    else if (selTradeOf == ENUM_TRADEOF_CODE.Rejection)
      return ENUM_TRADEOF_TYPE.Rejection
  }
  const [dataFooter, setDataFooter] = useState(downloadDataFooter)
  useEffect(() => {
    if (rows && rows.length > 0 && initialColumn && initialColumn.length > 0) {
      const footerData = filterKeys(downloadDataFooter, initialColumn)
      setDataFooter(footerData)
    }

  }, [rows, initialColumn])


  useEffect(() => {
    if (modSettingParams && modSettingParams.length > 0) {
      setInitialColumn(modSettingParams)
      setExportData(exportColumns.filter(ele => modSettingParams.includes(ele.uid)))
    }
    else
      setInitialColumn(INITIAL_VISIBLE_COLUMNS)
  }, [modSettingParams])

  const handleAutoCompleteChange = (val) => {
    setSelTradeOf(val)
    setSelModName(getModSettingName(val))
  }

  const exportExcel = () => {
    exportToExcel({
      data: rows,
      downloadFileName: "Single_Packet_Stock",
      exportColumns: exportData
    })
  }

  const exportPdf = () => {
    exportToPDF(
      {
        data: rows,
        downloadFileName: "Single_Packet_" + getSelStockType() + "_Diamonds",
        exportColumns: exportData,
        exportReportType: "",
        downloadFileheader: [],
        downloadDataFooter: dataFooter,
      })
  }
 


  function CustomFooter() {
    //const totals = {};
    const apiRef = useGridApiContext();
    const visibleRowIds = apiRef.current.getSortedRowIds();

    // Build visible row data
    const visibleRows = useMemo(() => {
      return visibleRowIds.map((id) => apiRef.current.getRowWithUpdatedValues(id));
    }, [apiRef, visibleRowIds]);

    // Get visible columns (matching your column field list)
    const VisibleCol = useMemo(() => {
      return apiRef.current.getAllColumns().filter((col) =>
        initialColumn.includes(col.field)
      );
    }, [apiRef]);

    const totals = useMemo(() => {
      const result = {};
      VisibleCol.forEach((col) => {
        if (col.type === 'number') {
          result[col.field] = visibleRows
            .reduce((sum, row) => sum + (row[col.field] || 0), 0)
            .toFixed(2);
        } else {
          result[col.field] = '';
        }
      });
      return result;
    }, [VisibleCol, visibleRows]);


    return (
      <Box>
        <Box display="flex" overflow={"scroll"} width="100%" bgcolor="#f5f5f5" py={1}>
          {VisibleCol.map((col) => (

            <Box key={col.field} fontWeight={"bold"} minWidth={col.minWidth} textAlign="right"
              fontSize={"11px"} textTransform={"uppercase"} flex={col.flex}
            >
              {col.type == 'number' ? <div> <h6>{col.headerName}</h6> {totals[col.field]}</div> : ""}
            </Box>
          ))}
        </Box>

        <Box px={1} py={1}>
          <GridPagination />
        </Box>
        {/* <GridPagination /> */}
      </Box>
    );
  }

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Single Packet Stock " info={[]} breadcrumbs={["Stock", "Single"]}>
        <div className="flex w-full flex-col">

          <div className="flex  flex-wrap items-center gap-2  mb-2">
            <div className={`flex  items-center gap-2  ${isMobile ? 'w-full' : 'lg:w-3/5 sm:w-full'}`}>
              <Autocomplete
                size="sm"
                isRequired
                name={"item"}
                color={"danger"}
                label={"Stock Of"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}

                classNames={{
                  label: "text-xs text-black font-bold",
                }}
                isClearable={true}
                variant="flat"
                isVirtualized
                defaultItems={
                  ENUM_TRADEOF_LIST
                }
                onSelectionChange={handleAutoCompleteChange}
                selectedKey={selTradeOf}
              >
                {(list) => (
                  <AutocompleteItem
                    key={list.key}
                  >
                    {list.value}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              {/* <Autocomplete
                size="sm"
                name={"item"}
                label={"Product Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                // className="w-full"
                classNames={{
                  label: "text-xs text-black font-bold",
                }}
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData
                    ? itemMasterData : []
                }
                onSelectionChange={setSelectedItem}
                selectedKey={selectedItem}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Item_Code}
                  >
                    {list.Item_Desc}
                  </AutocompleteItem>
                )}
              </Autocomplete> */}

            </div>
            <div className={`flex  items-center gap-2 `}>
              <Button
                color="primary"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
              // isLoading={isPending}
              >
                Search
              </Button>
              <Button
                style={{ marginLeft: "5px" }}
                color="primary"
                startContent={<FontAwesomeIcon icon={faFilter} />}
                onPress={handleResetFilter}
              >
                Reset
              </Button>
            </div>
          </div>

        </div>
        <div className="flex gap-5 justify-end mb-5">
          <Button size="sm" isDisabled={rows.length <= 0 ? true : false} color="success" onPress={exportExcel}>Export Excel</Button>
          <Button size="sm" isDisabled={rows.length <= 0 ? true : false} color="danger" onPress={exportPdf}>Export PDF</Button>
        </div>

        {/* {
          data && data.length > 0 ? */}

        <Box sx={{ height: rows.length > 20 ? 500 : "auto", width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            columnHeaderHeight={35}
            rowHeight={30}

            initialState={data && data.length > 0 ? {
              pagination: { paginationModel: { pageSize: 50, page: 0 } },
            } : {}}
            slots={data && data.length > 0 ? {
              footer: CustomFooter,
            } : {}}
            getRowId={(row) => row.id}
            filterModel={filterModel}
            onFilterModelChange={handleFilterChange}
            getRowClassName={(params) => {
              if (params.id == 'total') {
                return 'jksticky-row';  // Add custom class to the last row
              }
              return 'row-class';
            }}
            sx={{

              '& .sticky-row': {
                position: 'sticky',
                bottom: 0,
                color: "#FFFFFF",
                backgroundColor: '#424242f5',
                zIndex: 10,
                fontSize: "12px"
              },
              '& .MuiDataGrid-columnHeaders': {
                position: 'sticky',
                top: 0,
                backgroundColor: '#fff',
                zIndex: 1,
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
              },
              '& .row-class:hover': {
                backgroundColor: '#ffeabc',
              },
              '& .row-class': {
                fontSize: '11px',
              },

            }}
            columnVisibilityModel={{
              [RowsField.Item]: setColumnVisiblity(RowsField.Item),
              [RowsField.LotNo]: setColumnVisiblity(RowsField.LotNo),
              [RowsField.PktNo]: setColumnVisiblity(RowsField.PktNo),
              [RowsField.Shape]: setColumnVisiblity(RowsField.Shape),
              [RowsField.Color]: setColumnVisiblity(RowsField.Color),
              [RowsField.Purity]: setColumnVisiblity(RowsField.Purity),
              [RowsField.Size]: setColumnVisiblity(RowsField.Size),
              [RowsField.ReportNo]: setColumnVisiblity(RowsField.ReportNo),
              [RowsField.LwRatio]: setColumnVisiblity(RowsField.LwRatio),
              [RowsField.Rate]: setCurrencyColumnVisiblity(RowsField.Rate),
              [RowsField.RateD]: setCurrencyColumnVisiblity(RowsField.RateD),
              [RowsField.Amount]: setCurrencyColumnVisiblity(RowsField.Amount),
              [RowsField.AmountD]: setCurrencyColumnVisiblity(RowsField.AmountD),
              [RowsField.ConvRate]: setCurrencyColumnVisiblity(RowsField.ConvRate),
            }}
          />
        </Box>
        {/* : <h2>Data Not Fount</h2>
        } */}
      </MainContainer>
    </div>
  )
}

export default Stock
